import { useScrmFetch } from "@/hooks/common/fetch/useFetch";

// iscrm email subscribe接口
export const usePostUserinfo = async ({ email, country, brand, language, lastName, firstName, productName, modelNumber, entrance = 'ES',consentForPrivacyPolicy } = {}) => {
	const brandMap = {
        'Pelonisv2': 'Pelonis',
	}
	
	return await useScrmFetch(`/web/edm/edmInfo/save`).post({
		email,
		country,
		touchPoint: 'Websites',
		entrance,
		language,
		brand: brandMap[brand] || brand, // 'Midea' || 'Toshiba' || 'Pelonis'
		lastName,
		firstName,
		productName,
		modelNumber,
		consentForPrivacyPolicy,
	  }).json();
}

// 获取到货通知
export const useGetArrivalNotice = async ({ email, site, brand,productVariantId,productName,productLink,productImgSrc} = {}) => {
	const brandMap = {
        'Pelonisv2': 'Pelonis',
	}
	const brandStr=brandMap[brand] || brand; // 'Midea' || 'Toshiba' || 'Pelonis'
	return await useScrmFetch(`/api/iscrm-edm/userCenterExternalApi/websiteArrivalNotice`).post({
		email,
		websiteName:brandStr+'_'+site,
		productVariantId,
		productName,
		productLink,
		productImgSrc
	}).json();
}





















  